import { InformationDialogType } from './information-dialog-type';
export interface InformationDialogData {
  title?: string;
  text?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  type?: InformationDialogType;
  rejectable?: boolean;
  timeLimit?: number;
  extraInformation?: string;
  tertiaryAction?: Function;
  tertiaryActionLabel?: string;
  id?: string;
  lineBreaks?: boolean;
  role?: string;
  preserveTitleFormatting?: boolean;
  ignoreReadOnlyAcceptButton?: boolean;
  ignoreReadOnlyRejectButton?: boolean;
  ignoreReadOnlyTertiaryButton?: boolean;
}

export type InformationDialogDataWithExtraComponent = InformationDialogData & { extraComponent: ExtraComponentData };

export interface ExtraComponentData {
  name: string;
  inputData: ExtraComponentInputData;
}

export interface ExtraComponentInputData {
  options?: { [key: string]: string | number | boolean }[];
  optionValue?: string;
  optionLabel?: string;
}

export type ExtraComponentReturnData = {
  data: string | boolean | number;
};

export type ReturnData<T> = T extends InformationDialogDataWithExtraComponent ? ExtraComponentReturnData : boolean;

export const ExtraComponentList = [
  {
    name: 'InputSelectComponent',
    component: () => import('../input-select/input-select.component').then((res) => res.InputSelectComponent),
  },
];
